<template>
  <div class="cs-purchase-providers">
    <Yapay :need-select-shipping="needSelectShipping" />
  </div>
</template>

<script>
import Yapay from './purchase/Yapay'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'Purchase',

  components: {
    Yapay
  },

  computed: {
    ...mapGetters('cart', ['requireShipping']),
    ...mapState('shipping', ['shipping']),

    needSelectShipping() {
      return this.requireShipping && this.shipping.price == null
    }
  }
}
</script>
